import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { HisBackendService } from 'hisng';
import { BusinesstripApplication, BusinesstripApplicationBackend, BusinesstripApplicationFactory } from '../model/businesstripapplication';

@Injectable()
export class BusinesstripApplicationService {

    constructor( private readonly backendService: HisBackendService ) { }

    saveBusinesstripApplication(
        businesstripApplication: BusinesstripApplication ): Observable<BusinesstripApplication> {

        if ( businesstripApplication.id !== undefined ) {
            return this.backendService.putData(
                `api/v1/rm/erp/businesstripapplication/${businesstripApplication.id}`,
                BusinesstripApplicationFactory.createFromFrontendModel( businesstripApplication ) )
                .pipe( map( ( response: BusinesstripApplicationBackend ) => {
                    return BusinesstripApplicationFactory.createFromBackendModel( response );
                } ) );
        } else {
            return this.backendService.postData( 'api/v1/rm/erp/businesstripapplication',
                BusinesstripApplicationFactory.createFromFrontendModel( businesstripApplication ) )
                .pipe( map( ( response: BusinesstripApplicationBackend ) => {
                    return BusinesstripApplicationFactory.createFromBackendModel( response );
                } ) );
        }
    }

    getBusinesstripApplicationById( id: number ): Observable<BusinesstripApplication> {
        return this.backendService.getData( 'api/v1/rm/erp/businesstripapplication/' + id )
            .pipe( map( ( response: BusinesstripApplicationBackend ) => {
                return BusinesstripApplicationFactory.createFromBackendModel( response );
            } ) );
    }


    canDeleteBusinesstripApplication( id: number ): Observable<string> {
        return this.backendService.getData( 'api/v1/rm/erp/businesstripapplication/canDeleteBusinesstrippApplication/' + id );
    }

    deleteBusinesstripApplication( id: number ): Observable<number> {
        return this.backendService.delete( 'api/v1/rm/erp/businesstripapplication/' + id );
    }
}
